import React from 'react';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
var DisabledVariant = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    var t = useTranslation().t;
    return (React.createElement(SolidButton, { className: className, size: size, variant: "main", priority: "primary", disabled: true }, t('deviation.tier.noSubscribing')));
};
DisabledVariant.displayName = 'DisabledVariant';
export default DisabledVariant;
//# sourceMappingURL=Disabled.js.map